import type { JSX } from 'react'

import { Sidebar, Skeleton } from '@buffer-mono/popcorn'

import { ChannelsSectionGroupSkeleton } from '../ChannelsSection/ChannelsSectionSkeleton'
import { GlobalButtonSkeleton } from '../GlobalButton'
import { MainSidebarFrame, MainSidebarHeader } from './MainSidebarFrame'

export function MainSidebarSkeleton({
  channelRows,
}: {
  channelRows?: number
}): JSX.Element {
  return (
    <MainSidebarFrame showEdgeTrigger={false}>
      <MainSidebarHeader
        logo={<Skeleton width={96} height={24} />}
        globalButton={<GlobalButtonSkeleton />}
      />
      <Sidebar.Content>
        <ChannelsSectionGroupSkeleton rows={channelRows} />
      </Sidebar.Content>
    </MainSidebarFrame>
  )
}
